import $ from 'jquery';

export default function () {
    const updateVisibility = function () {
        $('.go-to-top').toggleClass('visible', $(window).height() < $(document).height());
    };

    updateVisibility();
    $(window).on('load resize', updateVisibility);

    if (window.MutationObserver) {
        const observer = new MutationObserver(updateVisibility);
        observer.observe(document.body, { childList: true, subtree: true });
    }

    setTimeout(updateVisibility, 250);
    setTimeout(updateVisibility, 1000);

    $(document).on('click', '.go-to-top__inner', function () {
        const target = document.querySelector('.navbar') || document.body;
        target.scrollIntoView({ behavior: 'smooth' });
    });
};
